import React from 'react';
import { connect } from 'react-redux';
import { formatMoney } from 'accounting';

import { requestAddToCart } from 'services/actions/cartActions';
import BaseModal from 'shared-components/BaseModal/Modal';
import CloseButton from 'shared-components/CloseButton/CloseButton';

import {
  selectProductFromVariantId,
  selectVariant,
  selectVariantQuantity,
} from 'selectors/productsSelectors';
import { selectPageTrackingFullData } from 'selectors/trackingSelector';

import Divider from 'shared-components/Divider/Divider';

import { track, btnLocationEnum, segmentEnum } from 'utils/segment';
import Gallery from '../../Products/Gallery/Gallery';
import UpdateCartButton from '../../Products/UpdateCartButton/UpdateCartButton';
import ProductDetails from '../../ProductDetail/ProductDetails';

import styles from './LearnMoreModal.module.css';

const LearnMoreModal = ({
  variantId,
  product,
  variant,
  variantQuantity,
  trackingData,
  viewSize,
  closeModal,
}) => {
  const {
    name,
    percentOff,
    shortDescription,
    includes,
    features,
    color,
    design,
    size,
    dimensions,
    howToUse,
    ingredients,
    materials,
    techCompatibility,
    careInstructions,
    pao,
    additionalInformation,
    countryOfOrigin,
    dropshipDisclaimer,
    paoDisclaimer,
    cbdDisclaimer,
    description,
    brandName,
  } = product;
  const { salePrice, price, imageUrl, galleryUrls } = variant;
  const galleryUrlsWithPrimaryImage = [imageUrl, ...galleryUrls];

  const handleClickClose = (elementName) => {
    closeModal();
    track(segmentEnum.clickedElement, {
      ...trackingData,
      experience: btnLocationEnum.learnMore,
      element_name: elementName,
    });
  };

  return (
    <BaseModal
      isOpen
      onRequestClose={() => handleClickClose('Outside of Modal')}
      className={styles.learnMoreModal}
    >
      <div className={styles.container}>
        <CloseButton onClick={() => handleClickClose('X')} />
        <div className={styles.galleryContainer}>
          <Gallery
            images={galleryUrlsWithPrimaryImage}
            viewSize={viewSize}
            context="accordion"
          />
        </div>
        <div className={styles.learnMoreModalContent}>
          {brandName && <h6>{brandName}</h6>}
          <h1>{name}</h1>
          <h2>{formatMoney(salePrice)}</h2>
          <p>
            Regular Price: <span>{formatMoney(price)}</span>
            <span>{` (Save ${percentOff}%)`}</span>
          </p>
          <div className={styles.updateCartButtonContainer}>
            <UpdateCartButton
              productName={name}
              variant={{ ...variant, id: variantId, quantity: variantQuantity }}
              buttonLocation={btnLocationEnum.productCard}
              viewSize={viewSize}
            />
          </div>
          <Divider className={styles.divider} />
          <ProductDetails
            layout="small"
            shortDescription={shortDescription}
            includes={includes}
            features={features}
            color={color}
            design={design}
            size={size}
            dimensions={dimensions}
            howToUse={howToUse}
            ingredients={ingredients}
            materials={materials}
            techCompatibility={techCompatibility}
            careInstructions={careInstructions}
            pao={pao}
            additionalInfo={additionalInformation}
            countryOfOrigin={countryOfOrigin}
            dropshipDisclaimer={dropshipDisclaimer}
            paoDisclaimer={paoDisclaimer}
            cbdDisclaimer={cbdDisclaimer}
            description={description}
          />
        </div>
      </div>
    </BaseModal>
  );
};

function mapStateToProps(state, props) {
  const { variantId } = props;
  return {
    product: selectProductFromVariantId(state, { variantId }),
    variant: selectVariant(state, { variantId }),
    variantQuantity: selectVariantQuantity(state, { variantId }),
    trackingData: selectPageTrackingFullData(state),
    viewSize: state.viewState.viewSize,
  };
}

export default connect(mapStateToProps, { requestAddToCart })(LearnMoreModal);
